import { useState } from "react";

type Branch = {
  img: string;
  name: string;
  address: string;
  floorDoor?: string;
  district: string;
  phone: string;
  rating?: string;
  reviews?: number;
};

type City = {
  code: string;
  label: string;
  searchQuery: string;
  branches: Branch[];
};

const cities: City[] = [
  {
    code: "TR34",
    label: "İstanbul",
    searchQuery:
      "Fulya+Mahallesi+B%C3%BCy%C3%BCkdere+Caddesi+Quasar+%C4%B0stanbul+Residence+No%3A76+%C5%9Ei%C5%9Fli",
    branches: [
      {
        img: "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?auto=format&fit=crop&w=400&q=80",
        name: "İstanbul Merkez Ofis",
        address: "Fulya Mahallesi Büyükdere Caddesi Quasar İstanbul Residence No:76",
        floorDoor: "İç Kat: 13 Kapı: 1305",
        district: "Şişli/İstanbul",
        phone: "0 (212) 213 00 88",
        rating: "4,2",
        reviews: 28,
      },
      {
        img: "https://images.unsplash.com/photo-1581092160562-40aa08e78837?auto=format&fit=crop&w=400&q=80",
        name: "İstanbul Servis Merkezi",
        address: "Fulya Mahallesi Büyükdere Caddesi No:76 P3 Otopark Katı",
        district: "Şişli/İstanbul",
        phone: "0 (212) 213 00 88",
      },
    ],
  },
  {
    code: "TR06",
    label: "Ankara",
    searchQuery:
      "Balgat+1413.+Sok.+%C3%9Cst%C3%BCnkaya+Apt.+No%3A4%2FA+%C3%87ankaya+Ankara",
    branches: [
      {
        img: "https://images.unsplash.com/photo-1431540015161-0bf868a2d407?auto=format&fit=crop&w=400&q=80",
        name: "Ankara Ofisimiz",
        address: "Balgat Mah. 1413. Sok. Üstünkaya Apt. No:4/A",
        district: "Çankaya/Ankara",
        phone: "0 (312) 219 43 83",
      },
    ],
  },
  {
    code: "TR35",
    label: "İzmir",
    searchQuery:
      "Mansuro%C4%9Flu+Mah.+286%2F1+Sk.+No%3A15+K%3A6+D%3A36+Verapol+Plaza+Bayrakl%C4%B1+%C4%B0zmir",
    branches: [
      {
        img: "https://images.unsplash.com/photo-1497366811353-6870744d04b2?auto=format&fit=crop&w=400&q=80",
        name: "İzmir Ofisimiz",
        address: "Mansuroğlu Mah. 286/1 Sk. No:15 K:6 D:36 Verapol Plaza",
        district: "Bayraklı/İzmir",
        phone: "0 (212) 213 00 88",
      },
    ],
  },
];

const embedUrl = (c: City) =>
  `https://maps.google.com/maps?q=${c.searchQuery}&z=15&output=embed`;

const mapsHref = (b: Branch) =>
  `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
    `${b.name} ${b.address} ${b.district}`
  )}`;

const directionsHref = (b: Branch) =>
  `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(
    `${b.address} ${b.district}`
  )}`;

function Stars({ value }: { value: number }) {
  return (
    <span className="inline-flex items-center text-amber-500">
      {[0, 1, 2, 3, 4].map((i) => {
        const full = i + 1 <= Math.floor(value);
        const half = !full && i + 0.5 <= value;
        return (
          <svg key={i} width="11" height="11" viewBox="0 0 24 24" aria-hidden="true" className="block">
            <defs>
              <linearGradient id={`s-${i}-${value}`}>
                <stop offset="50%" stopColor="#f59e0b" />
                <stop offset="50%" stopColor="#e4ebf3" />
              </linearGradient>
            </defs>
            <path
              d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"
              fill={full ? "#f59e0b" : half ? `url(#s-${i}-${value})` : "#e4ebf3"}
            />
          </svg>
        );
      })}
    </span>
  );
}

export default function Offices() {
  const [selectedCode, setSelectedCode] = useState<string>(cities[0].code);
  const city = cities.find((c) => c.code === selectedCode) ?? cities[0];
  const primary = city.branches[0];

  return (
    <section className="bg-surface py-20">
      <div className="container-x">
        <div className="max-w-2xl">
          <p className="text-sm font-semibold uppercase tracking-[0.2em] text-brand">
            Ofislerimiz
          </p>
          <h2 className="mt-3 font-display text-3xl font-bold text-ink sm:text-4xl">
            Türkiye'nin Üç Stratejik Noktasında
          </h2>
          <p className="mt-3 text-muted">Şehir seçin, ofisimizi haritada görün.</p>
        </div>

        {/* ŞEHİR KUTULARI */}
        <div className="mt-10 flex flex-wrap gap-3">
          {cities.map((c) => {
            const isActive = selectedCode === c.code;
            return (
              <button
                key={c.code}
                type="button"
                onClick={() => setSelectedCode(c.code)}
                className={`flex min-w-[180px] flex-1 items-center justify-between gap-3 rounded-xl border px-5 py-4 text-left transition-colors sm:max-w-[240px] ${
                  isActive
                    ? "border-brand bg-brand text-white shadow-[0_8px_24px_-12px_rgba(26,108,228,0.6)]"
                    : "border-line bg-white text-ink hover:border-brand/40"
                }`}
              >
                <div>
                  <p className={`text-[10px] font-bold uppercase tracking-widest ${isActive ? "text-white/70" : "text-muted"}`}>
                    Şehir
                  </p>
                  <h3 className="mt-0.5 font-display text-lg font-bold leading-tight">{c.label}</h3>
                </div>
                <span className={`grid h-9 w-9 shrink-0 place-items-center rounded-full ${isActive ? "bg-white/15" : "bg-brand/10 text-brand"}`}>
                  <i className="ri-map-pin-line text-base"></i>
                </span>
              </button>
            );
          })}
        </div>

        {/* HARITA + BİLGİ */}
        <div className="mt-8 grid grid-cols-1 gap-6 lg:grid-cols-[1.5fr_1fr] lg:items-stretch">
          {/* SOL: Google Maps embed */}
          <div className="relative overflow-hidden rounded-2xl border border-line bg-white shadow-card">
            <div className="relative aspect-[4/3] w-full sm:aspect-[16/10] lg:aspect-auto lg:h-[520px]">
              <iframe
                key={selectedCode}
                title={`${city.label} C2TEK ofis konumu`}
                src={embedUrl(city)}
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                className="absolute inset-0 h-full w-full border-0"
                allowFullScreen
              />

              {/* Sol üst overlay info kart */}
              <div className="pointer-events-none absolute left-4 top-4 right-4 sm:right-auto sm:max-w-[300px]">
                <div className="pointer-events-auto overflow-hidden rounded-xl bg-white shadow-card ring-1 ring-line">
                  <div className="h-1 w-full bg-gradient-to-r from-brand via-brand-light to-brand" />
                  <div className="px-4 py-3">
                    <div className="flex items-start justify-between gap-2">
                      <h4 className="font-display text-sm font-bold leading-tight text-ink">
                        C2TEK Bilgi Teknolojileri
                      </h4>
                      <div className="flex shrink-0 items-center gap-1.5">
                        <a
                          href={mapsHref(primary)}
                          target="_blank"
                          rel="noopener noreferrer"
                          aria-label="Yeni sekmede aç"
                          className="grid h-7 w-7 place-items-center rounded-lg bg-surface text-brand transition-colors hover:bg-brand hover:text-white"
                        >
                          <i className="ri-arrow-right-up-line text-sm"></i>
                        </a>
                        <a
                          href={directionsHref(primary)}
                          target="_blank"
                          rel="noopener noreferrer"
                          aria-label="Yol tarifi al"
                          className="grid h-7 w-7 place-items-center rounded-lg bg-brand text-white transition-colors hover:bg-brand-dark"
                        >
                          <i className="ri-map-pin-line text-sm"></i>
                        </a>
                      </div>
                    </div>
                    <p className="mt-2 text-[11px] leading-snug text-muted">
                      {primary.address}
                      {primary.floorDoor ? `, ${primary.floorDoor}` : ""}, {primary.district}
                    </p>
                    {primary.rating && (
                      <div className="mt-2 flex items-center gap-1.5 text-xs">
                        <span className="font-bold text-ink">{primary.rating}</span>
                        <Stars value={parseFloat(primary.rating.replace(",", "."))} />
                        {primary.reviews ? (
                          <a href={mapsHref(primary)} target="_blank" rel="noopener noreferrer" className="text-brand hover:underline">
                            ({primary.reviews})
                          </a>
                        ) : null}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* SAĞ: ofis listesi + CTA */}
          <div className="flex flex-col gap-4 lg:h-[520px]">
            {city.branches.map((b) => (
              <a
                key={b.name}
                href={mapsHref(b)}
                target="_blank"
                rel="noopener noreferrer"
                className="group flex min-h-[150px] flex-1 items-stretch gap-0 overflow-hidden rounded-2xl border border-line bg-white transition-all hover:border-brand/30 hover:shadow-card"
              >
                <img
                  src={b.img}
                  alt={b.name}
                  className="h-full w-32 shrink-0 object-cover transition-transform duration-500 group-hover:scale-105 sm:w-40"
                  loading="lazy"
                />
                <div className="flex min-w-0 flex-1 flex-col justify-center gap-2 p-5">
                  <h3 className="font-display text-lg font-bold leading-tight text-ink transition-colors group-hover:text-brand">
                    {b.name}
                  </h3>
                  <p className="text-sm leading-relaxed text-muted">
                    {b.address}
                    {b.floorDoor ? ` • ${b.floorDoor}` : ""}
                  </p>
                  <div className="flex flex-wrap items-center gap-x-4 gap-y-1.5 text-sm">
                    <span className="inline-flex items-center gap-1.5 font-semibold text-brand">
                      <i className="ri-phone-line text-base"></i>
                      {b.phone}
                    </span>
                    <span className="inline-flex items-center gap-1.5 text-muted">
                      <i className="ri-map-pin-line text-base"></i>
                      {b.district}
                    </span>
                  </div>
                </div>
              </a>
            ))}

            {/* Alt: İletişim CTA */}
            <a
              href="/#iletisim"
              className="group relative flex min-h-[150px] flex-1 items-center justify-between gap-5 overflow-hidden rounded-2xl bg-navy p-6 text-white transition-transform hover:-translate-y-0.5"
            >
              <span aria-hidden="true" className="pointer-events-none absolute -right-10 -top-10 h-40 w-40 rounded-full bg-brand/20 blur-2xl" />
              <div className="relative flex flex-col justify-center gap-1.5">
                <p className="text-xs font-bold uppercase tracking-widest text-brand-light">
                  Bizimle İletişim
                </p>
                <h4 className="font-display text-lg font-bold leading-tight sm:text-xl">
                  Size en yakın ofisten ulaşalım
                </h4>
                <p className="text-sm leading-relaxed text-white/70">
                  Talep formunu doldurun, ekibimiz hızla geri dönsün.
                </p>
              </div>
              <span className="relative grid h-12 w-12 shrink-0 place-items-center rounded-full bg-brand text-white transition-transform group-hover:translate-x-1">
                <i className="ri-arrow-right-line text-xl"></i>
              </span>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
